import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addUnitMeasure = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/UOM', body);
  return data;
});
export const updateUnitMeasure = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(`/api/resource/UOM/${id}`, body);
  return data;
});
//

export const getUnitMeasure = catchAsync(async ({key="",value=""}) => {
  let baseUrl =  '/api/resource/UOM?fields=["enabled","uom_name","name","must_be_whole_number"]&order_by=modified desc&limit_page_length=0'
  if(value){
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
  );
  return data;
});
export const deleteUnitMeasure = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(`/api/resource/UOM/${record}`);
  return data;
});
export const getUnitMeasureDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/UOM/${id}`);
  return data;
});
